import { Pointer } from '@yleisradio/areena-types';

export const idFromPointer = (pointer: Pointer | undefined): string => {
  if (!pointer) {
    return '';
  }

  const uri = pointer.uri;
  let id;

  if (typeof uri === 'string') {
    switch (pointer.type) {
      case 'view': {
        const matches = uri.match(
          /.*\/(?:items|packages|services)\/((?:yle|\d+)[-\w]+).*/
        );

        if (matches) {
          id = matches[1];
        }
        break;
      }
      default: {
        const matches = uri.match(
          /^yleareena:\/\/(items|services|packages)\/([\w-]+)(\?.*)?$/
        );

        if (matches && matches.length === 4) {
          id = matches[2];
        }
      }
    }
  }

  return id || '';
};

export const idFromUri = (uri: string): string => {
  return idFromPointer({ uri: decodeURIComponent(uri) });
};
